<button *ngIf="row.id" type="button" class="btn btn-transparent" ngbTooltip="Descargar documento" container="body"
    (click)="onDownloadFile()">
    <i class="ft-download text-secondary"></i>
</button>

